import { Combinator } from 'utils/combinatorTypes';

export const NEW_WORKFLOW_ID = 0;

/* Maps to nodeSuperClass values in backend */
export const WORKFLOW_NODE_TYPES = {
  ACTION: 'WorkflowAction',
  FILTER: 'WorkflowFilter',
  TRIGGER: 'WorkflowTrigger',
};

/* Maps to nodeClass values used in backend */
export const WORKFLOW_ACTIONS = {
  AB_SPLIT: 'ABSplitFilter',
  ADD_CONTACT: 'AddUserToListAction',
  ADD_USER_TO_FB: 'AddUserToFacebookCustomAudienceAction',
  ATTRIBUTE_SPLIT: 'FieldSplitFilter',
  CALL_WEBHOOK: 'CallWebhookAction',
  CHANGE_CONTACT_FIELD: 'ChangeContactFieldAction',
  CHANNEL_OPT: 'ChannelOptimizedSendAction',
  DELAY: 'DelayAction',
  FIELDS_MATCH: 'FieldsMatchFilter',
  HOLD: 'HoldAction',
  HOLD_UNTIL_REPLY: 'HoldUntilReplyAction',
  MODIFY_CHANNEL_SUBSCRIPTION: 'ModifyChannelSubscriptionAction',
  MODIFY_MESSAGE_TYPE: 'ModifyMessageTypeSubscriptionAction',
  REMOVE_CONTACT: 'RemoveUserFromListAction',
  REMOVE_USER_FROM_FB: 'RemoveUserFromFacebookCustomAudienceAction',
  SEND_EMAIL: 'SendEmailAction',
  SEND_EMBEDDED: 'SendEmbeddedAction',
  SEND_IN_APP: 'SendInAppAction',
  SEND_PUSH: 'SendPushAction',
  SEND_SMS: 'SendSMSAction',
  SEND_WEB_PUSH: 'SendWebPushAction',
  SEND_WHATSAPP: 'SendWhatsAppAction',
  TRIGGER_WORKFLOW: 'TriggerWorkflowAction',
  UPDATE_CONTACT_WEBHOOK: 'UpdateUserProfileWebhookAction',
};

/* Maps to nodeClass values used in backend */
export const WORKFLOW_FILTERS = {
  AB_SPLIT: 'ABSplitFilter',
  ATTRIBUTE_SPLIT: 'FieldSplitFilter',
  FIELDS_MATCH: 'FieldsMatchFilter',
};

/* Maps to nodeClass values used in backend */
export const WORKFLOW_TRIGGERS = {
  ADDED_ITEM_TO_CART: 'AddedItemToCartTrigger',
  CLICKED_AN_EMAIL: 'ClickedAnEmailTrigger',
  CLICKED_AN_IN_APP: 'ClickedAnInAppTrigger',
  CLICKED_AN_SMS: 'ClickedAnSMSTrigger',
  CLICKED_A_WHATSAPP: 'ClickedWhatsAppTrigger',
  CLOSED_AN_IN_APP: 'ClosedAnInAppTrigger',
  DELETED_AN_IN_APP: 'DeletedAnInAppTrigger',
  DELIVERED_AN_IN_APP: 'DeliveredAnInAppTrigger',
  FIELD_CHANGED: 'FieldChangedTrigger',
  NEW_USER_CREATED: 'NewUserCreatedTrigger',
  OPENED_AN_EMAIL: 'OpenedAnEmailTrigger',
  OPENED_AN_IN_APP: 'OpenedAnInAppTrigger',
  OPENED_PUSH: 'OpenedPushTrigger',
  PURCHASED: 'PurchasedTrigger',
  RECEIVED_AN_SMS: 'ReceivedAnSMSTrigger',
  RECEIVED_A_WHATSAPP: 'ReceivedWhatsAppTrigger',
  RECEIVED_API: 'ReceivedApiTriggerTrigger',
  SCHEDULED_RECURRING_LIST: 'ScheduledRecurringListTrigger',
  SEND_AN_EMAIL: 'SentAnEmailTrigger',
  SEEN_WHATS_APP: 'SeenWhatsAppTrigger',
  SUBSCRIBED_TO_CHANNEL: 'SubscribedToChannelTrigger',
  SUBSCRIBED_TO_LIST: 'SubscribedToListTrigger',
  SUBSCRIBED_TO_MESSAGE_TYPE: 'SubscribedToMessageTypeTrigger',
  TRIGGERED_BY_WORKFLOW: 'TriggeredByWorkflowTrigger',
  TRIGGERED_CUSTOM_EVENT: 'TriggeredCustomEventTrigger',
  UNSUBSCRIBED_FROM_CHANNEL: 'UnsubscribedFromChannelTrigger',
  UNSUBSCRIBED_FROM_LIST: 'UnsubscribedFromListTrigger',
  UNSUBSCRIBED_FROM_MESSAGE_TYPE: 'UnsubscribedFromMessageTypeTrigger',
};

export const STO_FLAG = 'SendTimeOptimization';

export const EVENT_TYPES = {
  PURCHASE: 'Purchase',
};

export const WORKFLOWS_DOCUMENTATION_URL =
  'https://support.iterable.com/hc/en-us/sections/4404563206804-Journeys';

export const WORKFLOWS_ACADEMY_URL =
  'https://academy.iterable.com/page/full-catalog#product-feature_journeys';

// Rate limit values come back from backend as plural/uppercase
export enum RateLimitUnit {
  Second = 'SECONDS',
  Minute = 'MINUTES',
}

export const emptySearchQuery = {
  combinator: Combinator.And,
  searchQueries: [
    {
      combinator: Combinator.And,
      searchQueries: [
        {
          dataType: '',
          searchCombo: {
            combinator: Combinator.And,
            searchQueries: [
              {
                comparatorType: '',
                dataType: '',
                field: '',
                fieldType: '',
                value: '',
              },
            ],
          },
        },
      ],
    },
  ],
};
